/* STRANGE LOOP — theme behavior (vanilla JS, no dependencies) */
(function () {
  'use strict';

  /* ---------- Capability helpers ---------- */
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function finePointer() {
    return window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  }

  /* ---------- Mobile navigation ---------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    var close = document.querySelector('[data-nav-close]');
    if (!toggle || !drawer) return;
    function open() { drawer.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    function shut() { drawer.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Quantity steppers ---------- */
  function initSteppers() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty-btn') === 'up' ? 1 : -1;
          var min = parseInt(input.min, 10) || 1;
          var val = (parseInt(input.value, 10) || min) + step;
          if (val < min) val = min;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main] img');
      if (!mainImg) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          if (src) mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100);
    var locale = (document.documentElement.lang || 'en');
    var currency = window.__shopCurrency || 'USD';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var select = form.querySelector('select[name="id"]');
      var priceEl = document.querySelector('[data-price]');
      var submit = form.querySelector('[data-add-button]');
      var submitText = submit ? submit.querySelector('[data-add-text]') : null;

      function currentOptions() {
        var opts = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function setAvailability(group) {
        // grey out option values that have no available combination
        var opts = currentOptions();
        form.querySelectorAll('[data-option-index]').forEach(function (g) {
          var idx = parseInt(g.getAttribute('data-option-index'), 10);
          g.querySelectorAll('input').forEach(function (input) {
            var test = opts.slice();
            test[idx] = input.value;
            var match = variants.find(function (v) {
              return v.options.every(function (o, i) { return i === idx ? o === input.value : (opts[i] == null || o === opts[i]); });
            });
            input.disabled = !(match && match.available);
          });
        });
      }

      function update() {
        var opts = currentOptions();
        var variant = findVariant(opts);
        if (!variant) {
          if (submit) { submit.disabled = true; }
          if (submitText) submitText.textContent = window.__strings.unavailable || 'Unavailable';
          return;
        }
        if (select) select.value = variant.id;
        // price
        if (priceEl) {
          var html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
            priceEl.classList.add('price--on-sale');
          } else {
            priceEl.classList.remove('price--on-sale');
          }
          priceEl.innerHTML = html;
        }
        // availability
        if (submit && submitText) {
          if (variant.available) { submit.disabled = false; submitText.textContent = window.__strings.add || 'Add to cart'; }
          else { submit.disabled = true; submitText.textContent = window.__strings.soldOut || 'Sold out'; }
        }
        // url
        if (history.replaceState && variant.id) {
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }

      form.querySelectorAll('[data-option-index] input').forEach(function (input) {
        input.addEventListener('change', function () { setAvailability(); update(); });
      });
      setAvailability();
      update();
    });
  }

  /* ---------- Cart line item updates (cart page) ---------- */
  function initCart() {
    var root = document.querySelector('[data-cart]');
    if (!root) return;
    root.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Infinite marquee (announcement bar) ---------- */
  function initMarquee() {
    if (reducedMotion()) return;
    document.querySelectorAll('[data-marquee]').forEach(function (el) {
      var content = el.querySelector('.announcement__content');
      if (!content) return;
      var unitHTML = content.innerHTML.trim();
      if (!unitHTML) return;
      var sep = el.getAttribute('data-sep') || '';
      var speed = parseFloat(el.getAttribute('data-speed')) || 70; // px per second

      // keep the original copy for screen readers, hidden visually
      content.classList.add('visually-hidden');

      function build() {
        var old = el.querySelector('.marquee__track');
        if (old) old.remove();

        var track = document.createElement('div');
        track.className = 'marquee__track';
        track.setAttribute('aria-hidden', 'true');
        var group = document.createElement('div');
        group.className = 'marquee__group';
        track.appendChild(group);
        el.appendChild(track);

        var containerW = el.clientWidth || window.innerWidth || 1000;
        var guard = 0;
        do {
          var item = document.createElement('span');
          item.className = 'marquee__item';
          item.innerHTML = unitHTML + (sep ? '<span class="marquee__sep">' + sep + '</span>' : '');
          group.appendChild(item);
          guard++;
        } while (group.scrollWidth < containerW && guard < 60);

        var groupW = group.scrollWidth;
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);

        var dur = Math.max(8, groupW / speed);
        track.style.setProperty('--marquee-duration', dur + 's');
        el.classList.add('announcement--marquee');
      }

      build();

      // rebuild on resize so the loop stays seamless at any width
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(build, 200);
      });
    });
  }

  /* ---------- Tilt / depth product cards ---------- */
  function initTilt() {
    if (reducedMotion() || !finePointer()) return;
    var MAX = 12; // degrees
    document.querySelectorAll('.card').forEach(function (card) {
      var media = card.querySelector('.card__media');
      var frame = null;
      card.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;   // 0..1
          var py = (e.clientY - r.top) / r.height;   // 0..1
          var rx = (0.5 - py) * MAX;
          var ry = (px - 0.5) * MAX;
          card.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.02)';
          if (media) {
            media.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
            media.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
          }
          card.classList.add('is-tilting');
        });
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
        card.classList.remove('is-tilting');
      });
    });
  }

  /* ---------- Custom cursor ring + click ripples ---------- */
  function initCursor() {
    if (reducedMotion() || !finePointer()) return;

    var ring = document.createElement('div');
    ring.className = 'vpc-cursor';
    ring.style.opacity = '0';
    document.body.appendChild(ring);

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2; // target
    var rx = tx, ry = ty;                                        // rendered (eased)
    var seen = false;

    window.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      tx = e.clientX; ty = e.clientY; seen = true;
    }, { passive: true });

    function loop() {
      rx += (tx - rx) * 0.18;
      ry += (ty - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      if (seen) ring.style.opacity = '1';
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    var interactive = 'a, button, [role="button"], input, select, textarea, summary, label, .card';
    document.addEventListener('pointerover', function (e) {
      if (e.target.closest && e.target.closest(interactive)) ring.classList.add('is-active');
    });
    document.addEventListener('pointerout', function (e) {
      if (e.target.closest && e.target.closest(interactive)) {
        var to = e.relatedTarget;
        if (!to || !(to.closest && to.closest(interactive))) ring.classList.remove('is-active');
      }
    });

    window.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      var rip = document.createElement('div');
      rip.className = 'vpc-ripple';
      rip.style.left = e.clientX + 'px';
      rip.style.top = e.clientY + 'px';
      document.body.appendChild(rip);
      rip.addEventListener('animationend', function () { rip.remove(); });
    });
  }

  /* ---------- Init ---------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initNav();
    initReveal();
    initSteppers();
    initGallery();
    initProductForm();
    initCart();
    initMarquee();
    initTilt();
    initCursor();
  });
})();
